import { render } from "./base-alert.vue?vue&type=template&id=7f9828d8&scoped=true"
import script from "./base-alert.vue?vue&type=script&lang=js"
export * from "./base-alert.vue?vue&type=script&lang=js"

import "./base-alert.vue?vue&type=style&index=0&id=7f9828d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9828d8"]])

export default __exports__